module.exports = __webpack_public_path__ + "static/media/google_logo.d344f74c.svg";